/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatMoney } from "../functions/format-money.js";
import translateMixin from '../mixins/translate-mixin.js';

const __vue_script__ = {
  mixins: [translateMixin],
  props: ["errors", "showAmount", "amount", "disabled", "currency"],
  data() {
    var installments = 1;
    if (!window.is_foreign && window.product.order_installment === "desc") {
      installments = Object.keys(window.product.installments)[Object.keys(window.product.installments).length - 1];
    }
    
    return {
      showingHelp: false,
      form: {
        amount: this.amount,
        number: "",
        holder_name: "",
        exp_month: "",
        exp_year: "",
        cvv: "",
        installments: installments
      }
    }
  },
  computed: {
    installments() {
      var decSep = this.currency.prefix === "R$" ? ',' : '.';
      var thouSep = this.currency.prefix === "R$" ? '.' : ',';

      var installments = window.product.installments;
      if (window.is_foreign) {
        installments = { 1: installments[1] };
      }

      var result = [];
      var hasInterest = !window.product.is_tax_to_producer;
      for (var i in installments) {
        if (!this.showAmount) { 
          var value = installments[i];
        } else {
          var value = installments[i] * this.form.amount / installments[1];
        }
        var periodicity = window.plan && window.plan.periodicity ? ({
          "daily": "/dia",
          "weekly": "/semana",
          "monthly": "/mês",
          "bimonthly": "/bimestre",
          "quarterly": "/trimestre",
          "half-yearly": "/semestre",
          "yearly": "/ano",
        })[window.plan.periodicity] : "";

        result.push({
          id: i,
          name: `${i} x ${this.currency.prefix} ${formatMoney(value * this.currency.value, 2, decSep, thouSep)}${i > 1 && hasInterest ? '*' : ''} ${periodicity}`,
          value: i * value
        });
      }

      if (window.product.order_installment === "desc") {
        return result.reverse();
      }

      return result;
    }
  },
  watch: {
    'form.amount'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('change-amount', newVal);
      }
    },
    amount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.amount = newVal;
      }
    },
    form: {
      deep: true,
      handler () {
        this.$emit('change', this.form)
      }
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-credit-card position-relative" },
    [
      _vm.disabled ? _c("div", { staticClass: "disabler" }) : _vm._e(),
      _vm._v(" "),
      _vm.showAmount
        ? _c("form-group", {
            attrs: {
              "is-money": "true",
              label: "Valor no cartão",
              placeholder: "Digite o valor",
              icon: "icon-money",
              readonly: _vm.disabled,
              errors: _vm.errors.amount,
              id: "amount",
              type: "tel",
            },
            model: {
              value: _vm.form.amount,
              callback: function ($$v) {
                _vm.$set(_vm.form, "amount", $$v)
              },
              expression: "form.amount",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("form-group", {
        attrs: {
          label: _vm.$t("Número do cartão"),
          placeholder: "Ex: 1234 5678 1234 5678",
          icon: "icon-credit-card",
          readonly: _vm.disabled,
          errors: _vm.errors.number,
          id: "number",
          type: "tel",
          mask: "#### #### #### ####",
        },
        model: {
          value: _vm.form.number,
          callback: function ($$v) {
            _vm.$set(_vm.form, "number", $$v)
          },
          expression: "form.number",
        },
      }),
      _vm._v(" "),
      _c("form-group", {
        attrs: {
          label: _vm.$t("Titular do cartão"),
          placeholder: "Ex: Jhon Doe",
          icon: "icon-user",
          readonly: _vm.disabled,
          errors: _vm.errors.holder_name,
          id: "holder_name",
        },
        model: {
          value: _vm.form.holder_name,
          callback: function ($$v) {
            _vm.$set(_vm.form, "holder_name", $$v)
          },
          expression: "form.holder_name",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("label", { staticClass: "d-none d-lg-inline-block" }, [
            _vm._v(_vm._s(_vm.$t("Data de validade"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("form-group", {
                  attrs: {
                    placeholder: "MM",
                    readonly: _vm.disabled,
                    errors: _vm.errors.exp_month,
                    id: "exp_month",
                    type: "tel",
                    mask: "##",
                    masked: "",
                  },
                  model: {
                    value: _vm.form.exp_month,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "exp_month", $$v)
                    },
                    expression: "form.exp_month",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("form-group", {
                  attrs: {
                    placeholder: _vm.$t("AA"),
                    readonly: _vm.disabled,
                    errors: _vm.errors.exp_year,
                    id: "exp_year",
                    type: "tel",
                    mask: "####",
                    masked: "",
                  },
                  model: {
                    value: _vm.form.exp_year,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "exp_year", $$v)
                    },
                    expression: "form.exp_year",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("form-group", {
              attrs: {
                label: _vm.$t("Código de segurança"),
                placeholder: "CVV",
                "mobile-placeholder": "CVV",
                icon: "icon-lock",
                readonly: _vm.disabled,
                errors: _vm.errors.cvv,
                id: "cvv",
                type: "tel",
                mask: "####",
                "help-icon": true,
              },
              on: {
                "toggle-help": function ($event) {
                  _vm.showingHelp = !_vm.showingHelp
                },
                "close-help": function ($event) {
                  _vm.showingHelp = false
                },
              },
              model: {
                value: _vm.form.cvv,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "cvv", $$v)
                },
                expression: "form.cvv",
              },
            }),
            _vm._v(" "),
            _vm.showingHelp ? _c("cvv-help") : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("form-group", {
        attrs: {
          label: _vm.$t("Opções de parcelamento"),
          readonly: _vm.disabled,
          errors: _vm.errors.installments,
          id: "installments",
          select: true,
          options: _vm.installments,
        },
        model: {
          value: _vm.form.installments,
          callback: function ($$v) {
            _vm.$set(_vm.form, "installments", $$v)
          },
          expression: "form.installments",
        },
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/form-credit-card.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__